<template>
  <div class="header">
    <h1>东亚同文会对华调查活动专题数据库</h1>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
.header {
  background: linear-gradient(rgba(93, 64, 55, 0.8), rgba(93, 64, 55, 0.7)),
              url('../assets/header-image.jpg') no-repeat center center;
  background-size: cover;
  padding: 80px 15px;
  text-align: center;
  color: white;
  position: relative;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header h1 {
  position: relative;
  z-index: 2;
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  font-weight: 600;
  margin-bottom: 12px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.header p {
  position: relative;
  z-index: 2;
  font-size: clamp(0.9rem, 2vw, 1.1rem);
  max-width: min(800px, 90%);
  margin: 0 auto;
  opacity: 0.9;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

@media (max-width: 768px) {
  .header {
    min-height: 300px;
    padding: 60px 15px;
  }
}
</style>